module.exports = __webpack_public_path__ + "static/img/PC-5.949d3ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcyixuekao/PC-5.png
// module id = CwF0
// module chunks = 0